import WalletPage from '../pages/dashboard/components/pages/wallet/WalletPage';

export default function WalletRoute() {
  return <WalletPage />;
}
